import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addRoomToProperty } from '../../actions/propertyActions';

class NewRoomModal extends Component {
  constructor() {
    super();

    this.state = {
      name: '',
      price: '',
      type: ''
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { flatId } = this.props;

    if (this.props.properties.property !== nextProps.properties.property) {
      window.$(`#new-room-${flatId}`).modal('hide');

      this.setState({ name: '', price: '', type: '' });
    }
  }

  onChange(e) {
    e.preventDefault();

    this.setState({ [e.target.name]: e.target.value });
  }

  onSubmit(e) {
    e.preventDefault();
    const { flatId, propertyId } = this.props;

    const roomData = {
      name: this.state.name,
      price: this.state.price,
      type: this.state.type
    };

    this.props.addRoomToProperty(propertyId, flatId, roomData);
  }

  render() {
    const { flatId } = this.props;

    return (
      <div
        className="modal fade"
        id={`new-room-${flatId}`}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Create a new room
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="edit-section">
                <h3 className="heading">General Info</h3>

                <div className="row">
                  <div className="col-md-6">
                    <div className="field">
                      <h5 className="heading">Room Name</h5>
                      <input
                        type="text"
                        name="name"
                        placeholder="Room #1"
                        value={this.state.name}
                        onChange={this.onChange}
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="field">
                      <h5 className="heading">Price</h5>
                      <input
                        type="text"
                        name="price"
                        placeholder="120"
                        value={this.state.price}
                        onChange={this.onChange}
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="field">
                      <h5 className="heading">Type</h5>
                      <input
                        type="text"
                        name="type"
                        placeholder="Single"
                        value={this.state.type}
                        onChange={this.onChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn green-button"
                onClick={this.onSubmit}
              >
                Add New Room
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  properties: state.properties
});

export default connect(
  mapStateToProps,
  { addRoomToProperty }
)(NewRoomModal);
